export default {
  HEADER_MENU_TRANSITION_DURATION: 300
};
